import {
  computed,
  ComputedRef,
  MaybeRefOrGetter,
  ref,
  toValue,
  watchEffect,
} from "vue"

export const MerchantAssetsLoader = (
  group: string
): Record<string, () => Promise<unknown>> | undefined => {
  if (group === "good-feet") {
    return import.meta.glob(["./good-feet/*/*.(svg|png|ico|jpg)"], {
      query: "?url",
      import: "default",
    })
  }

  if (group === "dental-plus") {
    return import.meta.glob(["./dental-plus/*/*.(svg|png|ico|jpg)"], {
      query: "?url",
      import: "default",
    })
  }
}

type MerchantImageFileName = "logo" | "favicon" | "intro-background"

const findMerchantAsset = (group: string, file: MerchantImageFileName) => {
  const loadedAsset = MerchantAssetsLoader(group)
  if (loadedAsset) {
    return (
      loadedAsset[`./${group}/assets/${file}.png`] ||
      loadedAsset[`./${group}/assets/${file}.jpg`] ||
      loadedAsset[`./${group}/assets/${file}.svg`] ||
      loadedAsset[`./${group}/assets/${file}.ico`]
    )
  }
}

export const useMerchantAsset = (
  group: MaybeRefOrGetter<string | undefined | null>,
  file: MerchantImageFileName
): ComputedRef<string | undefined> => {
  const asset = ref<MerchantImageFileName>()

  watchEffect(async () => {
    const groupId = toValue(group)

    if (groupId) {
      const loader = findMerchantAsset(groupId, file)

      if (loader) {
        asset.value = (await loader()) as MerchantImageFileName
      }
    }
  })

  return computed(() => asset.value)
}

export const useMerchantLogoAsset = (
  group: MaybeRefOrGetter<string | undefined | null>
) => useMerchantAsset(group, "logo")

export const useMerchantIntroBackgroundAsset = (
  group: MaybeRefOrGetter<string | undefined | null>
) => useMerchantAsset(group, "intro-background")
